// Synchronous, irreversible-ish fold for correlation IDs.
// NOT cryptographic — only used to avoid sending raw auth UUIDs to third
// parties (Sentry distinct_id, session.did, etc.). 12 hex chars ~ 48 bits.
// Stable across reloads for the same input (no salt) — that's the point:
// the same authenticated user collapses to the same anonymous bucket
// without exposing the original identifier.

const PEPPER = "nickrobotic.obs.v1"; // domain-separate from other hashing
const FNV_OFFSET = 0xcbf29ce484222325n;
const FNV_PRIME = 0x100000001b3n;
const MASK64 = 0xffffffffffffffffn;

function fnv1a64(input: string): bigint {
  let h = FNV_OFFSET;
  for (let i = 0; i < input.length; i++) {
    h ^= BigInt(input.charCodeAt(i) & 0xff);
    h = (h * FNV_PRIME) & MASK64;
  }
  return h;
}

export function hashUserId(raw: string | null | undefined): string | null {
  if (!raw) return null;
  // Double-fold with pepper for slight avalanche; truncate to 12 hex chars.
  const a = fnv1a64(PEPPER + ":" + raw);
  const b = fnv1a64(raw + ":" + PEPPER + ":" + a.toString(16));
  const merged = (a ^ b) & MASK64;
  return merged.toString(16).padStart(16, "0").slice(0, 12);
}
